import { Injectable } from "@angular/core";

@Injectable()
export class UuidService {
  constructor() {}

  public create(length?: number) {
    const uuid = this.newUuid(length ? length : 4);
    let uuidArray: any = localStorage.getItem("uuidArray");
    if (uuidArray) {
      if (uuidArray.includes(uuid)) {
        this.create();
      }
    }
    uuidArray = uuidArray + "," + uuid;
    localStorage.setItem("uuidArray", uuidArray);
    return uuid;
  }

  private newUuid(length: number): string {
    if (
      typeof window !== "undefined" &&
      typeof window.crypto !== "undefined" &&
      typeof window.crypto.getRandomValues !== "undefined"
    ) {
      const buf: Uint16Array = new Uint16Array(8);
      window.crypto.getRandomValues(buf);
      return this.pad4(buf[0], length);
    } else {
      return this.random4();
    }
  }

  private pad4(num: number, length: number): string {
    let ret: string = num.toString(16);
    while (ret.length < length) {
      ret = "0" + ret;
    }
    return ret;
  }

  private random4(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
}
